import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import language files
import enTranslation from './lang/en/translation.json';
import skTranslation from './lang/sk/translation.json';

// Define resources
const resources = {
  en: { translation: enTranslation },
  sk: { translation: skTranslation },
};

i18n
  .use(initReactI18next) // Connects i18n to React
  .init({
    resources,
    lng: 'sk', // Default language
    fallbackLng: 'sk', // Fallback if translation not found
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
